var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#E1251B;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M76.1,38.1C76.1,17,59.1,0,38.1,0S0,17,0,38.1c0,7.1,2,13.8,5.4,19.5l-5,18.5L19,71c5.6,3.2,12.1,5.1,19,5.1 C59.1,76.1,76.1,59.1,76.1,38.1z M43.3,25.1c-1.2-1.1-2.8-1.6-4.9-1.6c-2,0-3.6,0.6-5,1.7c-1.3,1.1-2.3,2.9-2.8,5.2l-7.2-0.9 c0.2-3.3,1.6-6.1,4.2-8.4c2.6-2.3,6.1-3.5,10.3-3.5c4.5,0,8,1.2,10.7,3.5c2.6,2.3,4,5.1,4,8.2c0,1.7-0.5,3.4-1.5,4.9 c-1,1.5-3.1,3.6-6.2,6.3c-1.6,1.4-2.7,2.5-3.1,3.3s-0.6,2.3-0.5,4.5h-7.1c0-1,0-1.6,0-1.9c0-2.3,0.4-4.2,1.1-5.7 c0.8-1.5,2.3-3.1,4.6-5c2.3-1.9,3.6-3.1,4.1-3.6c0.7-0.9,1-1.9,1-3C45.1,27.5,44.5,26.2,43.3,25.1z M34.3,50.8h7.8v7.8h-7.8V50.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M100,67c0-12.7-7.2-23.7-17.7-29.2c0,0.1,0,0.2,0,0.3c0,24.3-19.8,44.1-44.1,44.1c-0.1,0-0.3,0-0.4,0 C43.3,92.8,54.3,100,67,100c6.1,0,11.9-1.7,16.8-4.6l16.1,4.6l-4.6-16.1C98.3,79,100,73.2,100,67z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon2);
export default __webpack_public_path__ + "static/media/icon-2.8309685e2c2ad8866db5a718d9e8e6c5.svg";
export { ForwardRef as ReactComponent };